// Actions/contactUsActions.js
import api from "lib/api/api";

// Send Contact Us form
export const contactUsAction = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "CONTACT_US_REQUEST" });

    await api.post("v1/contact-us", formData);

    dispatch({ type: "CONTACT_US_SUCCESS" });
    return true;
  } catch (error) {
    dispatch({
      type: "CONTACT_US_FAIL",
      payload: error.response?.data || "Something went wrong",
    });
    return false;
  }
};
